import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=b547d0a4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Folder.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Folder.vue
// module id = 2302
// module chunks = 1